<template>
    <div class="flex flex-col py-6 pl-6 pr-2 w-80 bg-white flex-shrink-0" style="margin: 1.5rem 0px 1.5rem 0px">
        <div class="flex flex-col items-center border border-gray-200 w-full py-6 px-4 rounded-lg">
            <div class="h-20 w-20 rounded-full border overflow-hidden">
                <user-avatar :avatar-url="authUser().avatar_url" :username="authUser().name"></user-avatar>
            </div>
            <div class="text-lg font-semibold mt-2">{{ authUser().name }}</div>
        </div>
        <div class="flex flex-col mt-8">
            <div class="flex flex-row items-center justify-between text-xs">
                <span class="font-bold">Active Conversations</span>
                <span class="flex items-center justify-center bg-gray-300 h-4 w-4 rounded-full">{{ conversations.length }}</span>
            </div>
            <div
                v-if="conversations.length > 0"
                class="flex flex-col space-y-1 mt-4 -mx-2 overflow-y-auto"
                style="height: 540px;"
            >
                <button
                    v-for="conversation in conversations"
                    :key="conversation.id"
                    :class="isActive(conversation)"
                    class="flex flex-row items-center hover:bg-gray-100 rounded-xl p-2 text-left focus:outline-none"
                    @click="$emit('conversation-selected', conversation.conversation_id)"
                >
                    <template v-if="conversation.project">
                        <button
                            class="relative z-10 block h-12 w-12 rounded-full overflow-hidden border-2 border-teal-500 focus:outline-none focus:border-gray-300"
                        >
                            <project-avatar :avatar-url="null" :projectname="conversation.project.slug"></project-avatar>
                        </button>
                        <div class="ml-2 text-sm font-semibold">
                            <div>
                                {{ conversation.project.title }}
                                <!--                                <span v-show="conversation.conversation.last_message.is_seen == 0" class="absolute items-center justify-center text-xs text-white bg-red-500 h-2 w-2 rounded leading-none"></span>-->
                            </div>
                            <p v-if="conversation.conversation.last_message" class="text-gray-500 overflow">
                                {{ conversation.conversation.last_message.body }}
                            </p>
                        </div>
                    </template>
                    <template v-else>
                        <div v-for="participant in conversation.conversation.participants" :key="participant.id" class="flex">
                            <button
                                v-if="authUser().name !== participant.messageable.name"
                                class="relative z-10 block h-12 w-12 rounded-full overflow-hidden border-2 border-teal-500 focus:outline-none focus:border-gray-300"
                            >
                                <user-avatar
                                    :avatar-url="participant.messageable.avatar_url"
                                    :username="participant.messageable.name"
                                ></user-avatar>
                            </button>
                            <div v-if="authUser().name !== participant.messageable.name" class="ml-2 text-sm font-semibold">
                                <div>
                                    {{ participant.messageable.name }}
                                    <!--                                    <span v-show="conversation.conversation.last_message.is_seen == 0" class="absolute items-center justify-center text-xs text-white bg-red-500 h-2 w-2 rounded leading-none"></span>-->
                                </div>
                                <p v-if="conversation.conversation.last_message" class="text-gray-500 overflow">
                                    {{ conversation.conversation.last_message.body }}
                                </p>
                            </div>
                        </div>
                    </template>
                </button>
            </div>
            <div v-else class="mt-64 flex flex-col space-y-1 mt-4 -mx-2 h-48 overflow-y-auto">
                <p>You Don't have any conversation yet!</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        conversations: {
            type: Array,
            required: true
        },
        selectedConversationId: {
            type: Number,
            required: true
        }
    },

    methods: {
        isActive: function(conversation) {
            return {
                active: this.selectedConversationId === conversation.conversation_id,
                unread: conversation.conversation.last_message ? conversation.conversation.last_message.is_seen == 0 : false
            };
        }
    }
};
</script>

<style scoped>
.active {
    background: rgba(235, 244, 255, var(--bg-opacity));
}

.overflow {
    text-overflow: ellipsis;
    width: 15em;
    white-space: nowrap;
    overflow: hidden;
}

.unread {
    border-right: 3px solid #38b2ac;
}
</style>
